import React, {useEffect, useState} from 'react'
import PropTypes from "prop-types"
import ModalForm from '../../../../components/modalComponents/ModalForm'

import {
   editarConfiguracionAprobadoresCondicionesAPI,
   getAllConfiguracionAprobadoresCondicionesAPI,
   getResponsableEmpleadoAPI
} from "../../../../consumers/backendApisUrls";
import {useSubmitForm} from "../../../../hooks/useSubmitForm/useSubmitForm";
import {useManageGetRequest} from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import {useManagePostRequest} from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import {mapDropDownOptionsFromBackendToSelectOptionsNeededForLibrary} from "../../../../helper/utils";
import TableWebBody from "./TableWebBody";

const KEYS = ["IdNivelAprobacion", "IdAprobador", "IdAprobadorAlternativo"]
const SECTION_NAME = "ConfiguracionNivelesAprobacion";

const NivelesAprobacion = ({toggleModal}) => {
    const [filas, setFilas] = useState([]);
    const [allAprobadores, setAllAprobadores] = useState([]);
    const [filasEditar, setFilasEditar] = useState([]);
    const [submitForm] = useSubmitForm();

    const [manageGetRequest] = useManageGetRequest();
    const [managePostRequest] = useManagePostRequest();

    const init = async () => {
        try {
            await getAprobadores();
            await manageSearch();
        } catch (error) {
            console.error(error);
        }
    };

    const getAprobadores = async () => {
        let api = getResponsableEmpleadoAPI()
        let payload = {Criteria: ""}
        await managePostRequest(api, payload, successGetAprobadoresCallback, false);
    }

    const successGetAprobadoresCallback = (res) => {
        let data = res.data;
        let valueText = mapDropDownOptionsFromBackendToSelectOptionsNeededForLibrary(data);
        setAllAprobadores(valueText)
    }

    const editarFila = (obj) => {
        const filaOriginal = {...obj};
        setFilasEditar([...filasEditar, filaOriginal]);
        const estadoEditar = filas.map(fila => {
            if (fila.IdConfiguracionAprobadoresCondiciones === obj.IdConfiguracionAprobadoresCondiciones) {
                fila.EstadoEditar = true;
            }
            return fila;
        });
        setFilas(estadoEditar)
    }

    const onSubmit = async (obj) => {
        await submitForm(KEYS, editarConfiguracionAprobadoresCondicionesAPI(), obj, SECTION_NAME, successSubmitCallback);
    }

    const successSubmitCallback = () => {
        manageSearch();
    }

    const manageSearch = async () => {
        const api = getAllConfiguracionAprobadoresCondicionesAPI()
        await manageGetRequest(api, successGetAllCallBack, false);
    }

    const successGetAllCallBack = (res) => {
        let data = res.data;
        setFilas(data);
    }

    const cancelarSubmit = (id) => {
        if (typeof id != 'string') {
            const filaOriginal = filasEditar.filter(o => o.IdConfiguracionAprobadoresCondiciones == id)[0];
            const insertFilaOriginal = filas.map(fila => {
                if (fila.IdConfiguracionAprobadoresCondiciones == id) {
                    fila = filaOriginal;
                }
                return fila;
            });
            setFilas(insertFilaOriginal);
            const clearFilaOriginal = filasEditar.filter(filaEditar => filaEditar.IdConfiguracionAprobadoresCondiciones != id);
            setFilasEditar(clearFilaOriginal);
        } else {
            const clearFilaOriginal = filas.filter(fila => fila.IdConfiguracionAprobadoresCondiciones != id);
            setFilas(clearFilaOriginal);
        }
    }

    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            init();
        }

        return () => {
            unmounted = true;
        };
    }, []);

    return (
        <ModalForm
            titulo="Niveles de aprobación"
            width="1100px"
            showModal={toggleModal}
            hasSaveButton={false}
        >

            <div className="container-fluid body-content">
                <div className="table-responsive form-group-sm pt-2">
                    <table className="table table-hover">
                        <thead className="listar-thead">
                        <tr>
                            <th className="col-2">
                                <div className="flex font-gothan-medium">Nivel de aprobación</div>
                            </th>
                            <th className="col-3">
                                <div className="flex font-gothan-medium">Aprobador</div>
                            </th>
                            <th className="col-3">
                                <div className="flex font-gothan-medium">Aprobador alternativo</div>
                            </th>
                            <th className="col-1">
                                <div className="flex font-gothan-medium">Acciones</div>
                            </th>
                        </tr>
                        </thead>
                        <TableWebBody
                            filas={filas}
                            setFilas={setFilas}
                            editarFila={editarFila}
                            allAprobadores={allAprobadores}
                            onSubmit={onSubmit}
                            cancelarSubmit={cancelarSubmit}
                            SECTION_NAME={SECTION_NAME}
                        />
                    </table>
                </div>
            </div>
        </ModalForm>
    );
}

NivelesAprobacion.propTypes = {
    toggleModal: PropTypes.func.isRequired,
    refreshPage: PropTypes.func
}

export default NivelesAprobacion;